  <!--
   功能名称:千里眼平台(技师)-会员管理(间隔时长筛选)
   开发人:梁高权
   创建时间:2021/03/14
   最后修改时间:2021/03/14
   -->
<template>
<van-form @submit="onSubmit">
  <div class="form-item">
    <div class="title">间隔时长</div>
    <GRadioButton :radioList="intervalDayList" :value="num" @Gradio="Gradio" />
  </div>
  <div class="form-item">
    <div class="title">自定义</div>
    <van-field v-model="num" maxlength="10" name="interval_day" type="digit" label="会员近" label-width="100px">
        <template #button>天没来消费</template>
    </van-field>
  </div>
  <div class="button-box">
    <van-button  round  color="#666666" native-type="button" plain @click="reset">重置</van-button>
    <van-button round color="#4F57FB"  type="info" native-type="submit">确定</van-button>
  </div>
</van-form>
</template>

<script>
import { Toast } from 'vant';
export default{
  name:'intervalDay',
  components:{'GRadioButton':()=>import('@/components/GRadioButton')},
  props:{
    interval_day:{
      type:Number,
      default:0
    }
  },
  watch:{
    interval_day:{
      handler(newVal,oldVal){
        this.num=newVal
      },
      immediate:true,
      deep:true
    }
  },
  data() {
    return {
      intervalDayList:[
        {title:'半个月',value:15},
        {title:'一个月',value:30},
        {title:'三个月',value:90},
        {title:'半年',value:180}
      ],
      num: ''
    };
  },
  methods: {
    onSubmit(values) {
      if(!values.interval_day) values.interval_day=0
      else values.interval_day=parseFloat(values.interval_day);
      if (values.interval_day>=10&&values.interval_day <= 1000) {
        this.$emit('onConfirm',values)
      } else {
        Toast.fail('间隔时长不能低于10天')
      }
    },
    reset(){
      this.num=0
      this.$emit('onReset','重置所有')
    },
    Gradio(value){
      this.num=value
    }
  }
}
</script>

<style lang="scss" scoped>
 .form-item{
   padding: 0 35px 25px;
   border-bottom: 1px solid #F0F0F0;
   .title{font-size: 24px;color: #999;font-weight: 500;line-height: 70px;}
   /deep/.van-cell__title{line-height: 50px;font-size: 28px;color: #666;font-weight: 500;}
   /deep/.van-field__body{
     input{
       border: 2px solid #EEEEEE;
       padding-left: 18px;
       border-radius: 26px;
       line-height: 50px;
     }
     .van-field__button{
       font-size: 28px;color: #666;font-weight: 500;
     }
   }
 }
 .button-box{
   display: flex;
   margin: 25px 30px;
   /deep/ .van-button{flex: 1;height: 60px;}
   /deep/ .van-button--default{border: 2px solid #EEEEEE !important;background: #F5F5F5;margin-right: 25px;}
 }
</style>
